import { errorLogger } from "@/Common/helpers/logger";
import { signOut, fetchAuthSession } from "aws-amplify/auth";

// eslint-disable-next-line no-undef
const defaultBaseUrl = `${import.meta.env.VITE_APP_AWS_APPSYNC_RTC}`;

//* Tag for graphql format
export const gql = String.raw;

const userSignOut = (): void => {
	signOut({ global: true });
	window.localStorage.clear();
	window.location.href = "/login";
};

const headers: HeadersInit = {
	"Content-Type": "application/json",
};

const fetchWithAuth = async (_url: string, options: { method: string; body: string; compress: boolean }) => {
	let session;
	try {
		session = await fetchAuthSession({ forceRefresh: true });
	} catch (error) {
		errorLogger(error as Error);
	}
	const idToken = session?.tokens?.idToken;

	if (!idToken) {
		userSignOut();
	}

	headers["Authorization"] = `Bearer ${idToken}`;

	const { compress, ...restOptions } = options;
	if (compress) {
		headers["Content-Encoding"] = "gzip";
	}

	const config = {
		...restOptions,
		headers,
	};

	const baseUrl = `${defaultBaseUrl}`;

	const response = await fetch(baseUrl, config);
	const data = await response.json();

	if (!response.ok || data.errors?.length > 0) {
		throw new Error(data.errors ? data.errors[0].message : "Request failed");
	}

	return { data };
};

const apiInstance = {
	async post(url: string, data: unknown, config = { compress: false }) {
		const options = { method: "POST", body: JSON.stringify(data), compress: config.compress };
		return fetchWithAuth(url, options);
	},
	async put(presignedUrl: string, data: Blob | File | ArrayBuffer, options = {}) {
		return fetch(presignedUrl, {
			method: "PUT",
			body: data,
			...options,
		});
	},
	async get(url: string) {
		return fetch(url, {
			method: "GET",
		});
	},
};

export { apiInstance };
